import React, { useState, useEffect, useContext } from 'react';
import { CrudProviderInventoryRecord } from '../../Components/Cruds/CrudProviderInventoryRecord';
import { getUserPermissionsByUserEmail } from '../../api/usersModule/getters';
import { NotFoundPage } from '../NotFoundPage/NotFoundPage';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import UserContext from '../../utils/Contexts/UserContext';

// NOTA: Verificar el nombre correcto del módulo en Cognito
// Puede ser "Reportes", "Informes", "DetalleInventarioProveedores", etc.
const moduleName = 'Skus';

/**
 * ProviderInventoryDetailPage
 *
 * Página de detalle de inventario por proveedor con estilos unificados
 * Compatible con el sistema de diseño de DailyInventoryDistributionReport
 *
 * Fuente de datos:
 * - Endpoint: /skusRecords
 * - Tabla: SKUsRecords
 * - Filtros: Fecha, Proveedores, SKUs activos
 *
 * Métricas mostradas:
 * - Evolución de inventario por color
 * - Evolución de SKUs por estado
 * - Matriz de alertas críticas
 * - Cumplimiento de ROP
 * - Desempeño por proveedor
 * - Salud del inventario en el tiempo
 * - Análisis de riesgo por proveedor
 */
export const ProviderInventoryDetailPage = () => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = useContext(UserContext);

  const getPermissions = async () => {
    setLoading(true);

    let permissions = {
      Consultar: false,
      Crear: false,
      Editar: false,
      Eliminar: false,
    };

    try {
      permissions = await getUserPermissionsByUserEmail(
        user.attributes['email'],
        user.attributes['custom:project'],
        moduleName
      );

      setUserPermissions(permissions);
      setLoading(false);
    } catch (error) {
      console.error('Error getting permissions:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
  }, []);

  return (
    <>
      {userPermissions && userPermissions['Consultar'] ? (
        <div
          style={{
            flex: '1 1 auto',
            display: 'flex',
            flexFlow: 'column',
            height: '100vh',
            overflowY: 'auto',
            backgroundColor: '#f9fafb'
          }}
        >
          <div
            style={{
              padding: '24px',
              maxWidth: '100%'
            }}
          >
            <CrudProviderInventoryRecord
              userName={user.attributes['family_name']}
              permissions={userPermissions}
              project={user.attributes['custom:project']}
            />
          </div>
        </div>
      ) : loading ? (
        <LoadingPage />
      ) : (
        <NotFoundPage />
      )}
    </>
  );
};

export default ProviderInventoryDetailPage;
